import Axios from 'axios'
import FileSaver from 'file-saver'
import moment from 'moment'
const MINUTES_TO_WAIT_IN_MILLISECONDS = 2 * 60 * 1000

export const getCurrencyTypes = async () => {
  const response = await Axios.get('/currencies/listCurrencyTypes')
  return response
}

export const uploadReceipt = async (params) => {
  const formData = new FormData()

  // Extract files from positions and collect them
  const files = []
  const processedPositions = params.positions.map((position, index) => {
    if (position.checkImage && position.checkImage.originFileObj) {
      // Add file to files array with position index reference
      files.push({
        file: position.checkImage.originFileObj,
        positionIndex: index,
      })

      // Return position without the file object, just indicate it has a file
      return {
        ...position,
        checkImage: true,
      }
    }

    return {
      ...position,
      checkImage: null,
    }
  })

  // Add files to FormData if they exist
  if (files.length > 0) {
    files.forEach((fileData) => {
      formData.append(`file_${fileData.positionIndex}`, fileData.file)
    })
  }

  // Prepare clean params object without file objects
  const cleanParams = {
    ...params,
    positions: processedPositions,
  }

  formData.append('all', JSON.stringify(cleanParams))

  const response = await Axios.post('/provisionalReceipts/uploadProvisionalReceipts', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response
}

export const submitReceipts = async (params) => {
  const response = await Axios.post('/billingDetails/submitReceipts', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response
}

export const getBanks = async () => {
  const response = await Axios.get('/banks/listBanks')
  return response
}

export const getBankReferencesApi = async () => {
  const response = await Axios.get('/bankReferences/listBankReferences')
  return response
}

export const getTaxWithholdingsTypes = async () => {
  const response = await Axios.get('/taxWithholdings/listTaxWithholdingsTypes')
  return response
}

export const getProvisionalReceipts = async () => {
  const response = await Axios.get('/provisionalReceipts/getProvisionalReceipts')
  return response
}

export const getProvisionalReceiptsByFilter = async ({
  sellerId,
  clientId,
  dateFrom,
  dateTo,
  isExport,
  page = 1,
  pageSize = 10,
}) => {
  const config = {
    params: {},
    responseType: isExport ? 'arraybuffer' : 'json',
    timeout: MINUTES_TO_WAIT_IN_MILLISECONDS,
  }

  if (sellerId) config.params.sellerId = sellerId
  if (clientId) config.params.clientId = clientId
  if (dateFrom) config.params.dateFrom = dateFrom
  if (dateTo) config.params.dateTo = dateTo
  if (isExport) config.params.isExport = isExport
  config.params.page = page
  config.params.pageSize = pageSize

  const response = await Axios.get('/provisionalReceipts/getProvisionalReceiptsByFilter', config)

  if (isExport && response && response.data) {
    FileSaver.saveAs(
      new Blob([response.data]),
      `ProvisionalReceipts-${moment().format('YYYYMMDD')}.xlsx`,
      {
        autoBOM: true,
      },
    )
  } else {
    return response.data
  }
}

export const resendProvisionalReceiptEmailApi = async (id) => {
  const response = await Axios.post(`/provisionalReceipts/resendProvisionalReceiptEmail/${id}`)
  return response.data
}

export const deleteReceipt = async (params) => {
  const response = await Axios.post('/provisionalReceipts/cancelReceipt', params)
  return response.data
}

export const downloadProvisionalReceiptApi = async (payload) => {
  const { id, receiptNumber } = payload

  const response = await Axios.get(`/provisionalReceipts/${id}/pdf`, {
    responseType: 'arraybuffer',
  })
  if (response && response.data) {
    const filename = `recibo-provisorio-${receiptNumber}.pdf`
    FileSaver.saveAs(new Blob([response.data], { type: 'application/pdf' }), filename, {
      autoBOM: true,
    })
  }
}

export const getProvisionalReceiptByIdApi = async (id) => {
  const response = await Axios.get(`/provisionalReceipts/getProvisionalReceiptById/${id}`)
  return response.data
}
